import { css } from "@emotion/react";
import GBtn from "./GBtn";

type Props = React.ComponentProps<typeof GBtn>;

export default function GBtnWave(props: Props) {
  const waveStyles = css`
    position: relative;

    &:hover {
      filter: brightness(1) !important;
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -10;
      background: #eae9e9;
      border-radius: ${props.radius}px;
      opacity: 0.7;
    }

    &:hover::before {
      animation: pulse 1.5s ease-out infinite;
    }

    &:hover::after {
      animation: pulse 1.5s 0.4s ease-out infinite;
    }

    @keyframes pulse {
      100% {
        transform: scale(2.5);
        opacity: 0;
      }
    }
  `;

  return <GBtn css={waveStyles} {...props}></GBtn>;
}

// We need to add the below in framer
/*

addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Buttons",
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
        fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
    
})
*/
